import React from 'react';
import './debtList.css';
import { useDispatch, useSelector } from "react-redux";
import { setDebtListAction } from "../../redux/rootReducer";
import { DEBT_LIST_INITIAL } from "../../redux/initialStateConstant";
import { getPaymentByIdThunk } from "../../redux/thunks/getPaymentByIdThunk";

const DebtList = () => {
    const dispatch = useDispatch();
    const debt_list = useSelector(state => state.debt_list);

    if (!debt_list.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setDebtListAction(DEBT_LIST_INITIAL)) }/>
                        <div className="form__title">Список долгов</div>
                    </div>
                    <div className="form__field">
                        {
                            debt_list.debt_list.length
                                ?
                                <>
                                    <div className="table__row table__row--header debt__item">
                                        <div className="table__cell"/>
                                        <div className="table__cell">Сумма</div>
                                        <div className="table__cell">Дата</div>
                                    </div>
                                    {
                                        debt_list.debt_list.map((elem, index) => {
                                            return (
                                                <div className="table__row debt__item table__row--hover"
                                                     key={ elem.id }
                                                     onClick={ () => {
                                                         // Получаем данные платежа
                                                         dispatch(getPaymentByIdThunk({
                                                             id: elem.id
                                                         }));
                                                     } }
                                                >
                                                    <div className="table__cell">{ index + 1 }</div>
                                                    <div className="table__cell">{ elem.cost }</div>
                                                    <div className="table__cell">{ elem.date }</div>
                                                </div>
                                            );
                                        })
                                    }
                                </>
                                :
                                <div className="deposit__empty">Нет данных</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DebtList;